import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import EmailEditor from 'components/App/DesktopView/shared/Composer/Email/Editor'
import { colorPropUnless } from 'shared/ui/theme'

const ReplyEmailEditor = ({ className, isForwarding, ...rest }) => {
  return (
    <EmailEditor
      className={cn(className, 'toolbar-bottom', { isForwarding })}
      placeholder={'Type your reply here...'}
      {...rest}
    />
  )
}

export default styled(ReplyEmailEditor)`
  .mce-edit-area,
  .mce-tinymce > .mce-container-body.mce-stack-layout {
    background-color: ${colorPropUnless('isForwarding', 'forward')};
  }
`
